export enum EventType {
    CHAT_STARTED = 'chat_started',
    IN_PROGRESS = 'in_progress',
    ERROR = 'error',
    MESSAGE = 'message',
    INCOMPLETE = 'incomplete',
    PROMPT = 'prompt',
    COMPLETED = 'completed',
    IMAGE_CHAT = 'image_chat',
    GENERATION_STARTED = 'generation_started',
    THINKING = 'thinking',
    UPSCALING_STARTED = 'upscaling_started',
    USER_MESSAGE_CREATED = 'user_message_created',
    CHAT_UPDATED = 'chat_updated',
    ASSISTANT_MESSAGE_CREATED = 'assistant_message_created',
    FILES_UPLOADED ='files_uploaded',
    THREAD_UPDATED ='thread_updated',
    CREDITS_UPDATED = 'credits_updated',
    IMAGES_GENERATED = 'images_generated',
    CITATIONS = "citations",
  }

// Helper function to check if a string is a valid event type
export const isValidEventType = (type: string): type is EventType => {
    return Object.values(EventType).includes(type as EventType);
}